import flatpickr from 'flatpickr';

require("flatpickr/dist/themes/airbnb.css");

// import { Calendar } from '@fullcalendar/core';
// import listPlugin from '@fullcalendar/list';

window.flatpickr = flatpickr;

$(document).on('click', '.add_members', function (event) {
    $.ajax({
        url: $(this).data('url'),
        type: "GET",
        data: {
            project_id: $(this).data('project-id'),
        },
        success: function (response) {
            if (response) {
                $('.members').html(response);

            }
        },
    });
});

$(document).on('click', '.add_member_submit', function (event) {
    let project_id = $('.project_id').val();
    let member_id = $('.member_select option:selected').val();
    $.ajax({
        url: $(this).data('url'),
        type: "POST",
        data: {
            project_id: project_id,
            member_id: member_id,
        },
        success: function (response) {

            if (response.success === true) {
                $('.custom-js-members-replace').parent().find('.row').remove();
                $('.custom-js-members-replace').append(response.showMembers);
                swalNotificationMessage('success', 'Success', response.message, 'top-end', false, false, true, 2000);
            }

            if (response.addedUser !== undefined) {
                $(response.addedUser).prependTo($('.custom-append-user').find("[data-project-id='" + response.projectId + "']").closest('.list-inline-item'));
            }

            if (response.errorMessage !== undefined) {
                swalNotificationMessage('error', 'Error', response.errorMessage, null, true, 'Ok', false, null);
            }
        },
    });
});

$(".add_task").click(function (event) {
    let task_name = $('#task_name').val()
    let assignees = $('#assignees option').filter(":selected").val()
    let due_date = $('#due_date').val()
    let status = $('#statuses').val()
    let description = $('#task_description').val()
    let service_id = $('#task_service_id').val()
    let task_file = $('.task-file').prop('files')[0];
    let data = {
        task_name: task_name,
        assignees: assignees,
        due_date: due_date,
        description: description,
        status: status,
        service_id: service_id,
        task_file: task_file,
    }
    $.ajax({
        url: $(this).data('url'),
        type: "GET",
        data: data,
        success: function (response) {
            if (response.success === true) {
                $(".tasks_table >tbody").append(response.view);
                swalNotificationMessage('success', 'Success', response.message, 'top-end', false, false, true, 2000);
            }
        },
    });
});


$(".send_client_mail").click(function (event) {

    let subject = $('#subject').val()
    let message = $('#message').val()
    $.ajax({
        url: $(this).data('url'),
        type: "GET",
        data: {
            subject: subject,
            message: message,
        },
        success: function (response) {
            if (response.success === true) {
                swalNotificationMessage('success', 'Success', response.message, 'center', false, false, null, 2000);
            }
        },
    });
});

$(".send_client_sms").click(function (event) {

    let message = $('#sms_message').val()
    alert(message)
    $.ajax({
        url: $(this).data('url'),
        type: "GET",
        data: {
            message: message,
        },
        success: function (response) {
            if (response.success === true) {
                swalNotificationMessage('success', 'Success', response.message, 'center', false, false, null, 2000);
            }
        },
    });
});

$(document).on('click', ".add_material", function () {
    let project_id = $('.project_id').val(),
        supplier_id = $("select#supplier_id option").filter(":selected").val(),
        material_id = $(this).parents('body').find('#material_id option').eq(1).val(),
        qty = $(this).parents('.modal-content').find('[name=material_units_number]').val();

    $.ajax({
        url: $(this).data('url'),
        data: {
            project_id: project_id,
            supplier_id: supplier_id,
            material_id: material_id,
            qty: qty,
        },
        type: "GET",

        success: function (response) {
            if (response.success === true) {
                $(".custom-js-add-materials").parents('#suppliers-tab').find('.footable-empty').remove();
                $(".materials_table_suppliers > tbody").append(response.showMaterial);
                $('.custom-ajax-project-settings').replaceWith(response.projectSettingsView);
                swalNotificationMessage('success', 'Success', response.message, 'center', false, false, null, 2000);
            } else {
                swalNotificationMessage('error', 'Error', response.message, 'top-end', false, false, true, 2000);
            }
        },
    });
});

$(document).on('click', '.custom-js-add-materials', function () {
    let material_id = $(this).parents('body').find('#material_id option').eq(1).val(),
        project_id = $(this).parents('.mailbox-controls').find('input:hidden').val();

    $.ajax({
        url: $(this).data('url'),
        data: {
            project_id: project_id,
            material_id: material_id,
        },
        type: "POST",
        dataType: 'json',
        success: function (response) {
            if (response.success === true) {
                $(".custom-js-show-materials").html(response.select);
            } else {
                swalNotificationMessage('warning', 'Warning', response.message, 'center', false, false, null, 2500);
            }
        },
    });
});

$(document).on('change', '#material_id', function () {
    let supplier_id = $("select#supplier_id option").filter(":selected").val();
    let material_units_number = $("#material_units_number").val();

    $.ajax({
        url: $("select#material_id option").filter(":selected").data('url'),
        type: "GET",
        success: function (data) {
            $('.supplier-div').empty();
            $('.material_price_per_unit').text(data.materialPricePerUnit[supplier_id]);
            $('.total_material_costs').text(parseFloat(data.materialPricePerUnit[supplier_id]) * parseFloat(material_units_number))
            $('.supplier-div').append(data.select);
        }
    });
});

$(document).on('change', '#material_units_number', function () {
    let supplier_id = $("select#supplier_id option").filter(":selected").val();
    let material_units_number = $("#material_units_number").val();

    $.ajax({
        url: $("select#material_id option").filter(":selected").data('url'),
        type: "GET",
        success: function (data) {
            $('.material_price_per_unit').text(data.materialPricePerUnit[supplier_id]);
            $('.total_material_costs').text(parseFloat(data.materialPricePerUnit[supplier_id]) * parseFloat(material_units_number))
        }
    });
})

$(document).on('change', '.select-suppliers', function () {
    let supplier_id = $("select#supplier_id option").filter(":selected").val();
    let material_units_number = $("#material_units_number").val();

    $.ajax({
        url: $("select#material_id option").filter(":selected").data('url'),
        type: "GET",
        success: function (data) {
            $('.material_price_per_unit').text(data.materialPricePerUnit[supplier_id]);
            $('.total_material_costs').text(parseFloat(data.materialPricePerUnit[supplier_id]) * parseFloat(material_units_number))
        }
    });
})

// $(document).on('change', '.custom-js-checkbox', function (event) {
//     alert('test')
//     event.stopImmediatePropagation();
//     let ajaxData = {},
//         serviceIds = [];
//
//     if ($(this).find('.error').length) {
//         $(this).find('.error').remove()
//     }
//
//     $(this).parents('.form-group').find('input').each(function (index, value) {
//         let input = $(this),
//             inputId = $(value).attr('value'),
//             inputValue = $(this).parents('.form-group').find("[data-service-id='" + inputId + "']").val();
//
//         if (input.is(':checkbox') && input.is(':checked')) {
//             serviceIds.push($(this).val());
//         }
//
//         if (input.is(':checkbox')) {
//             ajaxData[inputId] = input.is(':checked') ? (!inputValue ? 1 : inputValue) : 0;
//         }
//     });
// alert(ajaxData)
//     $.ajax({
//         url: $(this).data('url'),
//         method: 'POST',
//         dataType: 'json',
//         data: {
//             services: ajaxData,
//             project_id: $(this).data('project-id'),
//             service_ids: serviceIds
//         },
//         success: function (data) {
//             if (data.success === true) {
//                 $('.total-service-costs').empty();
//                 $('.total-service-costs').append(data.totalServicePrice);
//                 $('.project-settings-tab').html(data.projectSettingsTab);
//                 $('.custom-ajax-project-settings').removeClass('d-none').addClass('d-flex');
//                 $('.project-service-material-wrapper').html(data.projectServiceMaterials);
//                 swalNotificationMessage('success', 'Success', data.message, 'center', false, false, null, 1500);
//                 $('.custom-ajax-project-settings').addClass('d-flex');
//
//                 setTimeout(function () {
//                     $('.custom-ajax-project-settings').trigger('change')
//                 }, 1000);
//             } else {
//                 swalNotificationMessage('error', 'Error', data.message, 'center', true, 'Ok', false, null);
//             }
//         }
//     });
//
//
// });


$(document).on('click', '.calculate-price', function (event) {

    let selected_items = $('.custom-js-checkbox');
    let checked_items = [];
    selected_items.each(function (key, value) {
        if ($(this).children().eq(0).is(':checked')) {
            checked_items[key] = $(this).children().eq(0);
        }
    })

    // $('.custom-js-distance').trigger('click');

    $(checked_items).each(function (key, value) {
        $(this).trigger('click').click();
    });

    setTimeout(function () {
        $('.custom-ajax-project-settings').trigger('change')
    }, 1500);
});

$('.custom-js-form-submit').on('submit', function (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if ($(this).find('.error').length) {
        $(this).find('.error').remove()
    }

    let serializedArray = $(this).serializeArray();
    $(this).find('input:checkbox').each(function () {
        ($(this).is(':checked') === false) ? serializedArray.push({
            name: this.name,
            value: null
        }) : $(this).serialize();
    });
    swalNotificationMessage('success', '', '','center', true, 'Ok', null, 500);

    $.ajax({
        url: $(this).data('url'),
        method: 'POST',
        dataType: 'json',
        data: serializedArray,
        success: function (data) {
            if (data.success == true) {
                swalNotificationMessage('success', 'Success', data.projectCreatedMessage, 'center', true, 'Ok', null, 50000);
                $('.custom-js-steps').removeClass('d-none');
                $('.custom-js-project-modal').removeClass('d-none');
                $('.project-settings-tab').replaceWith(data.project);
            } else {
                swalNotificationMessage('error', 'OBS!', data.message, 'center', true, 'Ok', null, 50000);

                setTimeout(function () {
                    window.location.replace(data.redirect);
                    window.clearTimeout(tID);		// clear time out.
                }, 5000);


            }

        },
        error: function (req) {
            let errorsHtml = '';

            $.each(req.responseJSON.errors, function (key, value) {
                errorsHtml += value[0] + '\r'; //showing only the first error.
            });

            // $.each(req.responseJSON.errors, function (index, value) {
            //
            //     let el = (index === 'services.0') ? $('.custom-js-checkbox').parents('.form-group') :
            //             (index === 'price_per_square_m' ? $('[name=' + index + ']').parent().parents('.form-group') :
            //                 $('[name=' + index + ']').parent()),
            //         error = '<span class="error" style="color: #ff413c;">' + value[0] + '</span>';
            //     el.append(error);
            // })

            swalNotificationMessage('error', 'OBS Feil', errorsHtml, 'center', true, 'Ok', false, 50000);

        }
    });

});

$(".client_attach").click(function (event) {
    let client_id = $("select.client_select option").filter(":selected").val();

    $.ajax({
        url: $(this).data('url'),
        type: "POST",
        data: {
            client_id: client_id,
        },
        success: function (response) {
            if (response) {
                $(".client_id").val(response);
                $(".client_info_holder").show().html(response.client_info)
                event.stopPropagation();
            }
        },
        error: function (xhr, desc, err) {
            console.log(err);
        }
    });
});

$('.add_new_client').on('click', function (event) {
    event.preventDefault();

    if ($(this).parents('.create_new_client').find('.error').length) {
        $(this).parents('.create_new_client').find('.error').remove()
    }

    $.ajax({
        method: 'POST',
        url: $(this).data('url'),
        dataType: "json",
        data: $(this).parents('.create_new_client').serialize(),
        success: function (data) {
            if (data.validatedClient !== undefined) {
                for (field in data.validatedClient) {
                    let el = $('[name=' + field + ']').parent();
                    for (message in data.validatedClient[field]) {
                        let error = '<span class="error" style="color: #ff413c;">' + data.validatedClient[field][message] + '</span>';
                        el.append(error);
                    }
                }
            } else {
                $('#add_new_client').modal('hide');
                $(".client_info_holder").show().html(data.clientInfo);
                swalNotificationMessage('success', 'Success', data.message, 'center', true, 'Ok', false, null);
            }
        },
        error: function (xhr, desc, err) {
            console.log(err);
        }
    });
});

$('.add_new_client_from_frontside').on('click', function (event) {
    event.preventDefault();

    if ($(this).parents('.create_new_client').find('.error').length) {
        $(this).parents('.create_new_client').find('.error').remove()
    }

    $.ajax({
        method: 'POST',
        url: $(this).data('url'),
        dataType: "json",
        data: $('.create_new_client_from_frontside').serialize(),
        success: function (data) {
            if (data.validatedClient !== undefined) {
                for (field in data.validatedClient) {
                    let el = $('[name=' + field + ']').parent();
                    for (message in data.validatedClient[field]) {
                        let error = '<span class="error" style="color: #ff413c;">' + data.validatedClient[field][message] + '</span>';
                        el.append(error);
                    }
                }
            } else {
                $('#add_new_client').modal('hide');
                $(".client_info_holder").show().html(data.clientInfo);
                swalNotificationMessage('success', 'Success', data.message, 'center', true, 'Ok', false, null);
            }
        },
        error: function (xhr, desc, err) {
            console.log(err);
        }
    });
})

$(document).on('click', '.custom-js-delete-member', function () {
    let memberId = $(this).data('member-id');

    $.ajax({
        method: 'POST',
        url: $(this).data('url'),
        dataType: "json",
        success: function (data) {
            $('.custom-js-delete-member').parent().find('[data-member-id=' + memberId + ']').parents('tr').first().remove();
            swalNotificationMessage('success', 'Success', data.message, 'center', true, 'Ok', false, null);
        },
        error: function (xhr, desc, err) {
            console.log(err);
        }
    });
});

$(document).ready(function () {
    if ($('.custom-js-update-job-details').length > 0) {
        Dropzone.autoDiscover = false;

        let myDropzone = new Dropzone('form.custom-ajax-files-upload', {
            paramName: 'images',
            thumbnailWidth: 150,
            thumbnailHeight: 150,
            autoProcessQueue: false,
            uploadMultiple: true,
            parallelUploads: 100,
            acceptedFiles: 'image/jpeg,image/png,image/gif,image/jpg,application/pdf',
            previewsContainer: "#previews",
            clickable: ".fileinput-button",
            success: function (data) {
                let responseData = data.xhr.response,
                    jsonResponseData = JSON.parse(responseData);

                if (jsonResponseData['errorMessage'] !== undefined) {
                    swalNotificationMessage('error', 'Error', jsonResponseData['errorMessage'], 'center', true, 'Ok', false, null);
                } else {
                    swalNotificationMessage('success', 'Success', jsonResponseData['message'], 'top-end', false, false, true, 1500);
                    $('.card-info').html(jsonResponseData['uploadedImages']);
                }
            }
        });

        $('.custom-js-check').parents('#actions').addClass('dropzone');

        myDropzone.on('addedfile', function (file) {
            $('.dz-progress').hide();
            file.previewElement.addEventListener("click", function () {
                myDropzone.removeFile(file);
            });
        });

        $('.add_files').on('click', function (e) {
            e.preventDefault();
            myDropzone.processQueue();

        });
    }
});

$(document).on('click', '.custom-ajax-file-delete', function () {
    let imageId = $(this).data('image-id');

    $.ajax({
        method: 'POST',
        url: $(this).data('url'),
        dataType: "json",
        success: function (data) {
            $('.custom-ajax-file-delete').parent().find('[data-image-id=' + imageId + ']').parents('tr').first().remove();
            swalNotificationMessage('success', 'Success', data.message, 'center', true, 'Ok', false, null);
        },
    });
});

$(document).ready(function () {
    if ($('.custom-js-date').length) {
        flatpickr($('.custom-js-date'), {
            enableTime: false,
            clickOpens: true,
            time_24hr: true,
            theme: 'airbnb',
            locale: {
                "firstDayOfWeek": 1 // start week on Monday
            },
            position: 'auto center',
            dateFormat: "d-m-Y",
            // minDate: 'today',
        });
    }
});
$(document).ready(function () {
    $(document).on('click', ".flatpickr-input", function () {
        flatpickr($('.flatpickr-input'), {
            enableTime: true,
            altInput: true,
            clickOpens: true,
            theme: 'airbnb',
            locale: {
                "firstDayOfWeek": 1 // start week on Monday
            },
            time_24hr: true,
            position: 'auto center',
            dateFormat: "d-m-Y",
            // minDate: "today",
            maxDate: new Date().fp_incr(128)
        });
    });
});


$(document).on('change', '.custom-ajax-project-settings', function () {
    let disabledInputs = $(this).find(':input:disabled').prop('disabled', false);

    $.ajax({
        method: 'POST',
        url: $(this).data('url'),
        dataType: "json",
        data: $(this).find(':input, select').serializeArray(),
        success: function (data) {

            if (data.message !== undefined) {
                swalNotificationMessage('error', 'Error', data.message, 'center', true, 'Ok', false, null);
            } else {
                $('.custom-ajax-project-settings').replaceWith(data.projectSettingsView);
                swalNotificationMessage('success', 'Success', data.message, 'center', false, null, null, 2000);
            }
        },
        error: function (data) {
            if ($('.custom-ajax-project-settings').find('.error').length) {
                $('.custom-ajax-project-settings').find('.error').remove();
            }
            $.each(data.responseJSON.errors, function (index, value) {
                let el = $('[name=' + index + ']').parent(),
                    error = '<span class="error" style="color: #ff413c;">' + value[0] + '</span>';
                el.append(error);
            });
        }
    });

    disabledInputs.prop('disabled', true)
});

$(document).on('click', '.custom-js-distance', function () {
    let codeFrom = $(this).parent().find('[name=postcode_from]').val(),
        codeTo = $(this).parent().find('[name=postcode_to]').val();

    $.ajax({
        url: $(this).data('url'),
        method: 'GET',
        dataType: 'json',
        data: {
            postcode_from: codeFrom,
            postcode_to: codeTo,
            project_id: $(this).data('project-id'),
        },
        success: function (data) {
            if (data.distanceInMiles !== undefined) {
                if (data.distanceInMiles.original !== undefined) {
                    swalNotificationMessage('error', 'Error', data.distanceInMiles.original.projectMsg, 'center', true, 'Ok', false, null);
                } else {
                    $('.distance-preview').val(data.distanceInMiles);
                    $('.distance-from-main-facility').val(data.distanceInMiles);
                    swalNotificationMessage('success', 'Success', data.message, 'top-end', false, false, true, 1000);
                }
            } else {
                swalNotificationMessage('error', 'Error', data.message, 'center', true, 'Ok', false, null);
            }
        },
        error: function (req) {
            if (req.responseJSON !== undefined || req.status === 500) {
                swalNotificationMessage('error', 'Error', req.responseJSON.message, 'center', true, 'Ok', false);
            }
        }
    })
});

$(document).on('click', '.custom-js-calc-surface', function () {
    let width = $(this).parent().find('#object_width').val(),
        height = $(this).parent().find('#object_height').val(),
        objectLength = $(this).parent().find('#object_length').val(),
        surfaceArea = 0;

    if ((width.length === 0) || (objectLength.length === 0)) {
        swalNotificationMessage('error', 'Error', 'Enter width/length for building', 'top-end', false, null, true, 5000);
    } else {
        if (height.length > 0) {
            surfaceArea = 2 * (objectLength * width + width * height + objectLength * height);
            $(this).parent().find('#object_sa').val(surfaceArea);
            swalNotificationMessage('success', 'Success', 'Success', 'top-end', false, null, true, 5000);
        } else {
            surfaceArea = width * objectLength;
            $(this).parent().find('.custom-js-sa').val(surfaceArea);
            swalNotificationMessage('success', 'Success', 'Success', 'top-end', false, null, true, 5000);
        }
    }
});

$(document).ready(function () {
    $(document).on('click', '.custom-js-calc-surface-square-meter', function () {
        let pricePerM = $(this).parent().find('#object_ppm2').val(),
            surfaceArea = $(this).parent().find('#object_sa').val(),
            projectId = $(this).data('project-id'),
            width = $(this).parent().find('#object_width').val(),
            height = $(this).parent().find('#object_height').val(),
            objectLength = $(this).parent().find('#object_length').val(),
            serviceId = $(this).parent().find('[name="custom_dimensions_service"]').val();

        $.ajax({
            url: $(this).data('url'),
            method: 'POST',
            dataType: 'json',
            data: {
                price_per_square_m: pricePerM,
                surface_area: surfaceArea,
                project_id: projectId,
                width: width,
                length: objectLength,
                height: height,
                service_id: serviceId,
            },
            success: function (data) {
                if (data.success === true) {
                    $('.custom-project-total-service').val(data.totalPrice.replace(' GBP', ''));
                    $('.total-service-costs').empty();
                    $('.total-service-costs').append(data.totalPrice);
                    $('.project-settings-tab').replaceWith(data.projectSettingsTab);
                    $('.custom-ajax-project-settings').removeClass('d-none').addClass('d-flex');
                    swalNotificationMessage('success', 'Success', data.message, 'top-end', false, null, true, 2000);
                } else {
                    swalNotificationMessage('error', 'Error', data.message, 'top-end', false, null, true, 5000);
                }
            }
        });
    });
});

$(document).on('click', '.custom-ajax-send-quote', function () {
    let projectId = $(this).data('project-id');
    $("#overlay").fadeIn(300);
    $.ajax({
        url: $(this).data('url'),
        method: 'POST',
        dataType: 'json',
        data: {
            project_id: projectId,
        },
        success: function (data) {
            if (data.success === true) {
                swalNotificationMessage('success', 'Success', data.message, 'center', true, 'OK', false, 2000);
                setTimeout(function () {
                    $("#overlay").fadeOut(300);
                }, 500);
            } else {
                swalNotificationMessage('error', 'Error', data.message, 'center', true, 'OK', false, 5000);
            }
        },
    });
});

$(document).on('click', '.custom-ajax-send-confirmation', function () {
    let projectId = $(this).data('project-id');

    $.ajax({
        url: $(this).data('url'),
        method: 'POST',
        dataType: 'json',
        data: {
            project_id: projectId,
        },
        success: function (data) {
            if (data.success === true) {
                swalNotificationMessage('success', 'Success', data.message, 'top-end', false, null, true, 2000);
            } else {
                swalNotificationMessage('error', 'Error', data.message, 'top-end', false, null, true, 5000);
            }
        },
    });
});

$(document).on('click', '.custom-ajax-view-job-sheet', function () {
    let projectId = $(this).data('project-id');

    $.ajax({
        url: $(this).data('url'),
        method: 'POST',
        dataType: 'json',
        data: {
            project_id: projectId,
        },
        success: function (data) {
            if (data.success === true) {
                // $('#view_job_sheet .container-fluid').html(data.view);
                $('#view_job_sheet').modal('show');
            } else {
                swalNotificationMessage('error', 'Error', data.message, 'top-end', false, null, true, 5000);
            }
        },
    });
});

$(document).ready(function () {
    $(document).on('click', '.custom-ajax-schedule-project', function () {
        let jobId = $(this).data('job-id');

        $.ajax({
            url: $(this).data('url'),
            method: 'POST',
            dataType: 'json',
            data: {
                project_id: jobId,
            },
            success: function (data) {
                // if (data.success === true) {
                //  swalNotificationMessage('error', 'Error', data.message, 'top-end', false, null, true, 5000);

                let schedulerWindow = window.open('', '_blank');
                schedulerWindow.location = data.redirectUrl;
                // } else {
                // }
            },
        });

    });
});

$(document).on('click', '.custom-js-set-job-hours', function () {
    let startHour = $(this).parents('#modal-job-details').find('[name=start_hour]').val();
     let   endHour = $(this).parents('#modal-job-details').find('[name=end_hour]').val();
      let  projectId = $(this).parents('#modal-job-details').find('[name=start_hour]').attr('data-job-id');
    let harbourId = $(this).parents('#modal-job-details').find('[name=harbour_id]').val();
    let status = $(this).parents('#modal-job-details').find('[name=status]').val();
    let eventId = $(this).data('event-id');
    let event_reason = $(this).parents('#modal-job-details').find('[name=event_reason]').val();

    let newProjectId = $('.manual_project_select option').filter(":selected").val()
    let project = ''
    if (projectId) {
        project = projectId
    } else {
        project = newProjectId
    }

    $.ajax({
        method: 'POST',
        url: $(this).data('url'),
        dataType: "json",
        data: {
            start_hour: startHour,
            end_hour: endHour,
            project_id: project,
            harbour_id: harbourId,
            status: status,
            event_id: eventId,
            event_reason: event_reason,
        },
        success: function (data) {
            if (data.success === true) {
                if (data.warningNote === 1) {
                    Swal.fire({
                        title: 'Warning',
                        text: data.message,
                        showDenyButton: true,
                        showCancelButton: false,
                        confirmButtonText: 'Proceed',
                        denyButtonText: 'Cancel',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $.ajax({
                                method: 'POST',
                                url: $('.custom-js-set-job-hours').data('url'),
                                dataType: "json",
                                data: {
                                    project_id: projectId,
                                    start_hour: startHour,
                                    end_hour: endHour,
                                    confirmed_with_warning: 1,
                                },
                                success: function (data) {
                                    if (data.success === true) {
                                        swalNotificationMessage('success', 'Success', data.message, 'center', true, null, null, 4000)
                                    }
                                },
                            });
                        } else if (result.isDenied) {
                            window.location.reload(false);
                        }
                    })
                } else {
                    swalNotificationMessage('success', 'Success', data.message, 'center', false, null, false, 1000);
                }
            } else {
                swalNotificationMessage('error', 'Error', data.message, 'center', false, null, false, 1000);
            }
        }
    });
});
$(document).ready(function () {
    if (window.location.href.indexOf("scanner") > -1) {
        let el = $('.custom-js-update-job-details').attr('auto-submit', '1')
        el.trigger('change')
    }
});

// $(document).ready(function () {
//     $.urlParam = function (name) {
//         var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
//         return results[1] || 0;
//     }
//     $.ulrParam = ('facility')
//     $('#facility').val(decodeURIComponent($.urlParam('facility')));
//     $('.custom-js-update-job-details').trigger('change');
//     $('.update-project-services').on('click', function () {
//         $('.custom-js-update-job-details').trigger('change');
//     })
//     swalNotificationMessage('success', 'Great Job!', 'Checked in:' + decodeURIComponent($.urlParam('facility')) + '. Now you can start sending offers. ', 'center', true, 'Ok', false, 4000);
//
//     if ($.urlParam('facility') && $.urlParam('scanner')) {
//         $('#collapseFive').addClass('show');
//         $('#collapseTwo').removeClass('show');
//     }
// });

$(document).ready(function () {
    $(document).on('change', '.custom-js-update-job-details', function () {
        $.ajax({
            url: $(this).data('url'),
            method: 'PUT',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf_token"]').attr('content')},

            dataType: 'json',
            data: $(this).find(':input').serializeArray(),
            success: function (data) {
                if (data.success === true) {
                    $('.custom-js-update-job-details').replaceWith(data.projectJobDetails);
                    swalNotificationMessage('success', 'Success', data.projectUpdatedMessage, 'top-end', false, null, true, 1500);
                } else {
                    swalNotificationMessage('error', 'Error', data.message, 'top-end', false, null, true, 5000);
                }
            },
            error: function (req) {
                $.each(req.responseJSON.errors, function (index, value) {
                    swalNotificationMessage('error', 'Errors', value[0], 'center', true, 'Ok', false, null);
                    let el = (index === 'services.0') ? $('.custom-js-checkbox').parents('.form-group') :
                            (index === 'price_per_square_m' ? $('[name=' + index + ']').parent().parents('.form-group') :
                                $('[name=' + index + ']').parent()),
                        error = '<span class="error" style="color: #ff413c;">' + value[0] + '</span>';
                    el.append(error);
                })
            }
        });
    });
});

$(document).on('change', '.custom-js-members-replace', function () {

    $.ajax({
        url: $(this).data('url'),
        method: 'POST',
        dataType: 'json',
        data: $(this).find('input[type=radio]').serializeArray(),
        success: function (data) {
            if (data.success === true) {
                swalNotificationMessage('success', 'Success', data.message, 'top-end', false, null, true, 1500);
            } else {
                swalNotificationMessage('error', 'Error', data.message, 'top-end', false, null, true, 5000);
            }
        },
    });
});

$(document).on('click', '.custom-js-delete-material', function () {
    let materialId = $(this).data('material-id');

    $.ajax({
        url: $(this).data('url'),
        method: 'POST',
        dataType: 'json',
        success: function (response) {
            if (response.success === true) {
                $('.custom-js-delete-material').parent().find('[data-material-id=' + materialId + ']').parents('tr').first().remove();
                $('.custom-ajax-project-settings').replaceWith(response.projectSettingsView);
                swalNotificationMessage('success', 'Success', response.message, 'top-end', false, false, true, 2000);
            } else {
                swalNotificationMessage('error', 'Error', response.message, 'top-end', false, false, true, 2000);
            }
        },
    })
});

$(document).ready(function () {
    $(document).on('click', '.custom-js-check-events', function () {
        let job_id = $(this).data('job-id');

        $.ajax({
            url: $(this).data('url'),
            method: 'POST',
            dataType: 'json',
            data: {
                job_id: job_id
            },
            success: function (data) {
                if (data.success === true) {
                    $('.custom-js-checked-events').html(data.checkedEventModal);
                    $('#checked_events').modal('show');

                    $.each($('#calendar').find('.fc-daygrid-day'), function () {
                        if (typeof $(this).attr('style') === 'string') {
                            $(this).css('background', '')
                        }
                    });

                    $.each(data.suggestedDates, function (key, value) {
                        let parsedDate = new Date(value).toISOString().substring(0, 10);
                        $('#calendar').find('[data-date=' + parsedDate + ']').css('background', '#3DFF33');
                    });
                } else {
                    swalNotificationMessage('error', 'Error', data.message, 'top-end', false, null, true, 5000);
                }
            },
        });
    });
});

$(document).ready(function () {
    $(document).on('click', '.custom-ajax-change-job-client', function () {
        let project_id = $(this).data('project-id'),
            client_id = $(this).parents('.modal-body').find('.client_select option').filter(':selected').val();

        $.ajax({
            url: $(this).data('url'),
            method: 'POST',
            dataType: 'json',
            data: {
                project_id: project_id,
                client_id: client_id,
            },
            success: function (response) {
                if (response.success === true) {
                    $('.client-wrapper').replaceWith(response.changedClient);
                    swalNotificationMessage('success', 'Success', response.message, 'center', false, false, false, 1000);
                } else {
                    swalNotificationMessage('error', 'Error', response.message, 'center', false, false, false, 1000);
                }
            },
        });
    });
});

$(document).ready(function () {
    $(document).on('click', '.custom-js-add-materials-tab', function () {
        $(this).parents('.content').find('.target-for-calc-materials').trigger('click');
    });
});

$(document).ready(function () {
    $(document).on('click', '.custom-ajax-preview-project-email', function () {
        let projectId = $(this).data('project-id'),
            confirmed = $(this).data('email-confirmed');

        $.ajax({
            url: $(this).data('url'),
            method: 'POST',
            dataType: 'json',
            data: {
                project_id: projectId,
                confirmed: confirmed,
            },
            success: function (response) {
                if (response.success === true) {
                    $('#preview_quote_email').replaceWith(response.previewQuoteModal);
                    $('#preview_quote_email').find('.ab-preview-quote-email').html(response.pdfPreview);
                    $('#preview_quote_email').modal('show');
                } else {
                    swalNotificationMessage('error', 'Error', response.message, 'top-end', false, null, true, 5000);
                }
            },
        });
    });
});

$(document).ready(function () {
    $(document).on('click', '.custom-ajax-send-test-mail', function () {
        let projectId = $(this).data('project-id'),
            type = $(this).data('email-type'),
            email = $(this).parents('.test-mail-wrapper').find('input').val();

        $.ajax({
            url: $(this).data('url'),
            method: 'POST',
            dataType: 'json',
            data: {
                project_id: projectId,
                email_type: type,
                test_email: email,
            },
            success: function (response) {
                if (response.success === true) {
                    swalNotificationMessage('success', 'Success', response.message, 'center', false, false, false, 1000);
                } else {
                    swalNotificationMessage('error', 'Error', response.message, 'center', true, 'Ok', false, 20000);
                }
            },
        });
    });
});

$(document).ready(function () {
    flatpickr($('.custom-js-index-flatpickr'), {
        mode: 'range',
        altInput: false,
        clickOpens: true,
        theme: 'airbnb',
        locale: {
            "firstDayOfWeek": 1 // start week on Monday
        },
        position: 'auto center',
        dateFormat: "d-m-Y",
    });
});

$(document).ready(function () {
    $(document).on('click', '#job-address-same', function () {
        $('.job-location').val($('.address').val())
    });

});

$(document).ready(function () {
    $(document).on('click', '.custom-js-set-service-id-dimensions', function () {
        let serviceId = $(this).data('service-id');
        $(this).parents('body').find('[name="custom_dimensions_service"]').prop('value', serviceId);
    });
});

$(document).ready(function () {
    $(document).on('click', '.custom-js-cancel-dimensions', function () {
        let serviceId = $(this).data('service-id'),
            projectId = $(this).data('project-id');

        $.ajax({
            url: $(this).data('url'),
            method: 'POST',
            dataType: 'json',
            data: {
                project_id: projectId,
                service_id: serviceId,
            },
            success: function (response) {
                if (response.success === true) {
                    $('.project-settings-tab').html(response.projectSettingsTab);
                    $('.custom-ajax-project-settings').removeClass('d-none').addClass('d-flex');
                    swalNotificationMessage('success', 'Success', response.message, 'center', false, false, false, 1750);
                } else {
                    swalNotificationMessage('error', 'Error', response.message, 'center', true, 'Ok', false, 20000);
                }
            },
        });
    });
});


function swalNotificationMessage(icon, title, text, position = null, showConfirmBtn = null, confirmBtnText = null, toast = null, timer = 5000) {
    Swal.fire({
        icon: icon,
        title: title,
        text: text,
        position: position,
        showConfirmButton: showConfirmBtn,
        confirmButtonText: confirmBtnText,
        toast: toast,
        timer: timer
    });
}


//Frontside


var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
$(document).ready(function () {
    if ($('#service_search').length > 0) {
        let url = $('#service_search').data('url');
        $("#service_search").autocomplete({
            source: function (request, response) {
                // Fetch data
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: "json",
                    data: {
                        _token: CSRF_TOKEN,
                        search: request.term
                    },
                    success: function (data) {
                        response(data);
                        // $('#description').html(response.description)
                    }
                });
            },
            select: function (event, ui) {
                $('#service_search').val(ui.item.label);
                $('#serviceid').val(ui.item.value);
                $('#description').text(ui.item.description)
                return false;
            }
        });
    }
});

$('.client_phone,.client_mail').on('blur', function () {


    $.ajax({
        method: 'GET',
        url: $(this).data('url'),
        dataType: "json",
        data: {
            field: $(this).val()
        },
        success: function (data) {

            if (data.success == true) {
                Swal.fire({
                    title: 'OBS!',
                    text: data.message,
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: 'Fortsett',
                    denyButtonText: 'Avbryt',
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.history.back()
                        // $('.contact_person').val(data.client.contact_person_name);
                        // $('.company').val(data.client.company_name);
                        // $('.postcode').val(data.client.postcode);
                        // $('.job-location').val(data.client.location);
                        // $('.number').val(data.client.number);
                        // $('.address').val(data.client.address);
                        // $('.client_phone').val(data.client.phone);
                        // $('.client_mail').val(data.client.email);
                        // swalNotificationMessage('success', 'Success', data.message, 'center', true, 'Ok', false, null);
                    } else if (result.isDenied) {
                        $('.custom-js-form-submit').reset();
                    }

                })
            }
        },
        error: function (xhr, desc, err) {
            console.log(err);
        }
    });
});

$('.delete_event').on('blur', function () {


    $.ajax({
        method: 'GET',
        url: $(this).data('url'),
        dataType: "json",
        data: {
            field: $(this).val()
        },
        success: function (data) {

            if (data.success == true) {
                Swal.fire({
                    title: 'Warning',
                    text: data.message,
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: 'Proceed',
                    denyButtonText: 'Cancel',
                }).then((result) => {
                    $('.contact_person').val(data.client.contact_person_name);
                    $('.company').val(data.client.company_name);
                    $('.postcode').val(data.client.postcode);
                    $('.job-location').val(data.client.location);
                    $('.number').val(data.client.number);
                    $('.address').val(data.client.address);
                    $('.client_phone').val(data.client.phone);
                    // swalNotificationMessage('success', 'Success', data.message, 'center', true, 'Ok', false, null);
                })
            }
        },
        error: function (xhr, desc, err) {
            console.log(err);
        }
    });
});


$(document).ready(function () {
    if ($('.frontside').length) {
        let selected_items = $('.custom-js-checkbox');

        selected_items.each(function (key, value) {
            if ($(this).children().eq(0).is(':checked')) {
                $(this).css({
                    "background-color": '#f7774c'
                });
            } else {
                $(this).css({
                    "background-color": '#DDDDDD'
                });
            }
        })
        $.urlParam = function (name) {
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
            return results[1] || 0;
        }

        // $('#referral_id').val($.urlParam('referral_id'))

        $(document).on('change', '.service_select', function () {

            if ($(this.checked)[0] == true) {
                if ($(this).data('roofable') == 1) {
                    $('.roof-types').removeClass('d-none');
                } else {
                    $('.roof-types').addClass('d-none');
                }
                $(this).parent().css({
                    "background-color": '#f7774c'
                });
                $('#service_dimensions').modal('show')
                //If surface area based type
                if ($(this).data('type') == 1) {
                    $('.standard-measurements').removeClass('d-none');

                }
                //if item based type
                else {
                    $('.standard-measurements').addClass('d-none');
                    $('.measurements').addClass('d-none');
                }

                $('.finish-custom-service-dimensions').data('service-id', $(this).val());
            }

            console.log($(this.checked))

            if ($(this.checked)[0] != true) {
                $('#service_dimensions').modal('hide')
                $(this).parent().css({
                    "background-color": '#DDDDDD'
                });
            }


        });

        $(document).on('click', '.custom-js-service-area-front', function () {
            $('.custom-service-calculator').removeClass('d-none');
            $('.standard-measurements').addClass('d-none');

        });

        $(document).on('click', '.finish-custom-service-dimensions', function () {
            let service_id = $(this).data('service-id');
            let serviceEl = $(".service_select[value='" + service_id + "']");
            //QTY
            let objectDimensionsInput = $('.custom-js-object-dimentions');
            serviceEl.siblings("#service_qty" + serviceEl.val()).val(objectDimensionsInput.val());
            objectDimensionsInput.empty();
            //Surface area
            let objectSurfaceAreaInput = $('.custom-js-sa');
            serviceEl.siblings("#service_area" + serviceEl.val()).val(objectSurfaceAreaInput.val());
            objectSurfaceAreaInput.empty();
            $('.custom-service-calculator').addClass('d-none');
        });
    }

});


$(document).on('click', '.delete-events', function () {
    let url = $(this).data('url');
    let jobId = $(this).data('job-id');
    let eventId = $(this).data('event-id');

    Swal.fire({
        title: 'Warning',
        text: 'Are you sure?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Proceed',
        denyButtonText: 'Cancel',
    }).then((result) => {
        if (result.isConfirmed) {
            $.ajax({
                method: 'POST',
                url: $(this).data('url'),
                data: {
                    'eventId': eventId
                },
                dataType: "json",
                success: function (data) {
                    $('#event' + eventId).remove();
                    swalNotificationMessage('success', 'Success', data.message, 'center', true, 'Ok', false, null);
                },
                error: function (xhr, desc, err) {
                    console.log(err);
                }
            });
        }
    });


});


$(document).on('change', '.manual_project_select', function () {
    console.log($(this).val())
    $('.custom-js-hour').attr('data-job-id', $(this).val())
    let url = $(this).data('url')
    let projectId = $('.custom-js-hour').attr('data-job-id')
    let newProjectId = $('.manual_project_select option').filter(":selected").val()

    let project = ''
    if (projectId) {
        project = projectId
    } else {
        project = newProjectId
    }

    $.ajax({
        method: 'POST',
        url: url,
        dataType: "json",
        data: {
            project_id: project,
        },
        success: function (data) {
            if (data.success === true) {
                // $('.custom-ajax-calendar-event').html(data.eventDetails);
                // $('#modal-job-details').find('[name="start_hour"]').prop('value', checkDateFormatted)
            } else {
                swalNotificationMessage('error', 'Error', data.message, 'center', true, 'Ok');
            }
        }
    });
})












//Calculator script

$(document).on('change', '#boat_size,#engine_type,.engine_type', function () {
    $('.total-price').text(0)
    var price = $("input[name='engine_type']:checked").data('price')
    var priceCancelPerFoot = 320
    var size = $('#boat_size').val()
    var totalPrice = (price * size);
    var totalPriceCancel = priceCancelPerFoot * size;
    if (totalPrice) {
        $('.total-price').text(parseFloat(totalPrice))
        $('.total-price-cancelation').text(parseFloat(totalPriceCancel))
    } else {
        $('.total-price').text(' ')
        $('.total-price-cancelation').text(' ')
    }

});
$(document).on('click', '#reservation-reminder', function () {
    let url = $(this).data('action');
    let project_id = $(this).data('project-id');
    Swal.fire({
        title: 'Are you sure?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
    }).then((result) => {
        if (result.isConfirmed) {
            $.ajax({
                method: 'GET',
                url: url,
                dataType: "json",
                data: {
                    project_id: project_id,
                },
                success: function (data) {
                    if (data.success === true) {
                        swalNotificationMessage('success', 'Success', data.message, 'center', true, 'Ok');
                    } else {
                        swalNotificationMessage('error', 'Error', data.message, 'center', true, 'Ok');
                    }
                }
            });
        }
    })
});
$(document).on('click', '#reservation-reminder', function () {
    let url = $(this).data('action');
    console.log(url)
    let project_id = $(this).data('project-id');
    Swal.fire({
        title: 'Are you sure?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
    }).then((result) => {
        if (result.isConfirmed) {
            $.ajax({
                method: 'GET',
                url: url,
                dataType: "json",
                data: {
                    project_id: project_id,
                },
                success: function (data) {
                    if (data.success === true) {
                        swalNotificationMessage('success', 'Success', data.message, 'center', true, 'Ok');
                    } else {
                        swalNotificationMessage('error', 'Error', data.message, 'center', true, 'Ok');
                    }
                }
            });
        }
    })
});


$(document).on('click', '#cancel_reservation', function (e) {

    var project = $(this).data('project').toString()
    Swal.fire({
        title: 'Ønsker du å slette den bestilling?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Ja',
        denyButtonText: 'Nei',
        customClass: {
            actions: 'my-actions',
            cancelButton: 'order-1 right-gap',
            confirmButton: 'order-2',
            denyButton: 'order-3',
        }
    }).then((result) => {
        if (result.isConfirmed) {
            $.ajax({
                method: 'GET',
                type: 'GET',
                url: $(this).data('url'),
                dataType: "json",
                data: {
                    event_id: $(this).data('event-id'),
                    job_id: $(this).data('job-id')
                },
                success: function (response) {
                    swalNotificationMessage('success', response.title, response.message, 'center', true, 'OK', null, null)
                }
            })

        } else if (result.isDenied) {
            Swal.fire('Reserved slot will not be cancelled', '', 'info')
        }
    })
});


$(document).on('click', '.update-project-services', function () {

    var data = $('.services-form').serialize()
    var url = $(this).data('url')
    var project = $('.project').val()
    swalNotificationMessage('info', 'Info', 'Service are being update and the price recalculated.....', 'center', true, 'Ok', false,);

    $.ajax({
        method: 'POST',
        url: url,
        dataType: "json",
        data: {
            data: data,
            project: project,
        },
        success: function (data) {
            if (data.success === true) {
                swalNotificationMessage('success', 'Success', data.message, 'center', true, 'Ok', false, 1000);
                $('.costs-overview-external').html(data.view)
                location.reload();

            } else {
                swalNotificationMessage('error', 'Error', data.message, 'center', true, 'Ok');
            }
        }
    });
})
// $(document).on('click', '.post_comment', function () {
//
//     var data = $('.services-form').serialize()
//     var url = $(this).data('url')
//     var project = $('.project').val()
//     swalNotificationMessage('info', 'Info', 'Comments are being updated', 'center', true, 'Ok', false,);
//     $.ajax({
//         method: 'GET',
//         url: url,
//         dataType: "json",
//         data: {
//             data: data,
//             project: project,
//         },
//         success: function (data) {
//             if (data.success === true) {
//                 swalNotificationMessage('success', 'Success', data.message, 'center', true, 'Ok', true, 1000);
//                 $('.costs-overview-external').html(data.view)
//                 location.reload()
//             } else {
//                 swalNotificationMessage('error', 'Error', data.message, 'center', true, 'Ok');
//             }
//         }
//     });
// })

$('.plus,.minus').on('click', function () {
    var data = $('.services-form').serialize()
    var url = $('.services-form').data('url')
    var project = $('.project').val()
    $.ajax({
        method: 'POST',
        url: url,
        dataType: "json",
        data: {
            data: data,
            project: project,
        },
        success: function (data) {
            if (data.success === true) {
                swalNotificationMessage('success', 'Success', data.message, 'top right', true, 'Ok', true, 1000);
                $('.costs-overview-external').html(data.view)
            } else {
                swalNotificationMessage('error', 'Error', data.message, 'center', true, 'Ok');
            }
        }
    });
})
$('.file').on('change', function (e) {
    e.stopPropagation();
});

$(document).on('click', '.view-service-history', function () {
    var id = $(this).data('identifier');
    var modal = $('.service-wrap').find('#viewServiceHistory' + id)
    var el = $(this).data('selector')

    $('#viewServiceHistory' + id).modal();
    var url = $(this).data('url')
    $.ajax({
        method: 'GET',
        url: url,
        dataType: "json",
        data: {
            identifier: id
        },
        success: function (data) {
            if (data.success) {
                swalNotificationMessage('success', 'Success', data.message, 'center', true, 'Ok', true, 1000);
                $('#' + el).html(data.view)
            } else {
                swalNotificationMessage('error', 'Error', data.message, 'center', true, 'Ok');
            }

        }
    });
})

$(document).on('click', '.complete-task', function () {
    var id = $(this).data('id');
    var el = $('.service-wrap').find('.complete-task' + id)
    var url = $(this).data('url')
    Swal.fire({
        title: 'Do you want to complete service tasks?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Yes',
        denyButtonText: 'No',
    }).then((result) => {
        if (result.isConfirmed) {
            $.ajax({
                method: 'POST',
                url: url,
                dataType: "json",
                data: {
                    id: id
                },
                success: function (data) {
                    if (data.success) {
                        swalNotificationMessage('success', 'Success', data.message, 'center', true, 'Ok', true, 1000);
                    } else {
                        swalNotificationMessage('error', 'Error', data.message, 'center', true, 'Ok');
                    }
                }
            })
        }
    })

    $(document).on('change', '.choose-order', function () {

        $.ajax({
            url: $(this).data('url'),
            method: 'POST',
            dataType: 'json',
            data: $(this).find('input[type=radio]').serializeArray(),
            success: function (data) {
                if (data.success === true) {
                    swalNotificationMessage('success', 'Success', data.message, 'top-end', false, null, true, 1500);
                } else {
                    swalNotificationMessage('error', 'Error', data.message, 'top-end', false, null, true, 5000);
                }
            },
        });
    });
})

//Get service_id in creating new insurance claim
$(document).on('click', '.js-insurance-claim', function () {
    let service_id = $(this).data('service-insurance-id');
    let service_name = $(this).data('service-name');
    let insurance_service_id = $('.modal-body').find('#service_id').val(service_id);
    let insurance_service_name = $('.modal-body').find('#service_name').val(service_name);
});
$(".insurance-claim").click(function () {
    let project_id = $('#project_id').val();
    let service_id = $('#service_id').val();
    let client_id = $('#client_id').val();
    let client_name = $('#client_name').val();
    let hin_number = $('#hin_number').val();
    let motor_number = $('#motor_number').val();
    let boat_damage_number = $('#boat_damage_number').val();
    let own_share = $('#own_share').val();
    let service_name = $('#service_name').val();
    let vessel_model = $('#vessel_model').val();
    let description = $('#insurance_description').val();
    let image = $('#insurance-file').val();
    if (vessel_model.includes('/')) {
        let charIndex = vessel_model.indexOf('/');
        vessel_model = vessel_model.substr(0, charIndex)
    }
    let client_phone = $('#client_phone').val();
    let data = {
        project_id: project_id,
        service_id: service_id,
        client_id: client_id,
        client_name: client_name,
        hin_number: hin_number,
        motor_number: motor_number,
        boat_damage_number: boat_damage_number,
        own_share: own_share,
        service_name: service_name,
        vessel_model: vessel_model,
        client_phone: client_phone,
        description: description,
        image: image
    }
    $.ajax({
        url: $(this).data('url'),
        type: "POST",
        data: data,
        success: function (response) {
            if (response.success === true) {
                swalNotificationMessage('success', 'Success', response.message, 'center', false, false, true, 3000);
                // console.log($('#insurance-claim').modal('hide'));
            }
        },
    });
});
$(document).on('click', '.new_season_order', function () {
    let reservationInfo = $('.new_season_reservation');
    let newReservationInput = $('.new_season_order');

    if (newReservationInput.is(':checked')) {
        console.log('if')
        newReservationInput.prop('checked', true);
        reservationInfo.css('display', 'block');
    } else {
        console.log('else')
        newReservationInput.prop('checked', false);
        reservationInfo.css('display', 'none');
    }
});

$(document).on('click', '#new_order_yes', function () {
    let lastStep = $(document).find('.collapseFive');
    let newOrderMarker = $(document).find('#newOrderYes');
    $('#agree_with_gdpr').prop('disabled', true)
    $('#accept_terms').prop('disabled', true)
    $('#new_order_no').prop('checked', false)
    if ($(this).is(':checked')) {
        $('#agree_with_gdpr').prop('disabled', false)
        $('#accept_terms').prop('disabled', false)
        lastStep.prop('disabled', false);
        newOrderMarker.val(1)
    } else {
        $('#agree_with_gdpr').prop('disabled', true)
        $('#accept_terms').prop('disabled', true)
        lastStep.prop('disabled', false);
        newOrderMarker.val(0)
    }
});

$(document).on('click', '#new_order_no', function () {
    $('#agree_with_gdpr').prop('disabled', true)
    $('#accept_terms').prop('disabled', true)
    let lastStep = $(document).find('.collapseFive');
    let newOrderMarker = $(document).find('#newOrderYes');
    $('#new_order_yes').prop('checked', false)

    if ($(this).is(':checked')) {
        $('#agree_with_gdpr').prop('disabled', false)
        $('#accept_terms').prop('disabled', false)
        lastStep.prop('disabled', false);
        newOrderMarker.val(0)
    } else {
        $('#agree_with_gdpr').prop('disabled', true)
        $('#accept_terms').prop('disabled', true)
        lastStep.prop('disabled', false);
    }
});

$(document).ready(function () {
    let gdprCheckbox = $(document).find('#agree_with_gdpr');
    let termsCheckbox = $(document).find('#accept_terms');
    let confirmButton = $(document).find('#departure-confirm');
    let lastStep = $(document).find('.collapseFive');

    confirmButton.prop('disabled', true);

    gdprCheckbox.add(termsCheckbox).on('change', function () {
        if (gdprCheckbox.is(':checked') && termsCheckbox.is(':checked')) {
            confirmButton.prop('disabled', false);
            confirmButton.prop('disabled', false);
            lastStep.prop('disabled', false);
        } else {
            confirmButton.prop('disabled', true);
            lastStep.prop('disabled', true);
        }
    });
});
